<!--
 * @Author: your name
 * @Date: 2022-03-15 13:43:01
 * @LastEditTime: 2022-10-13 14:38:45
 * @LastEditors: taoyan taoyan_work@163.com
 * @Description:
 * @FilePath: /大增长星妈会C端/xmh-front-content/src/components/home/homeBanner.vue
-->

<template>
  <div
    class="banner_recommend"
    v-if="bannerList != null && bannerList.length > 0"
  >
    <mySwiper
      :loop="bannerList.length > 1 ? true : false"
      :slidesNum="1"
      :autoplay="bannerList.length > 1 ? true : false"
      :autoplayNumber="3000"
      :paginationFlag="bannerList.length > 1 ? true : false"
      :swipeid="'banner_recommend_swiper'"
      @slideClick="toDetailBanner"
      @slideChange="slideChange"
    >
      <div
        class="swiper-slide homebann"
        slot="swiper-con"
        v-for="(banner, index) in bannerList"
        :data="JSON.stringify({xmhh5_home_banner_url: banner.jumpTargetUrl, banner_station: index+1, id: banner.id})"
        :databanner="JSON.stringify({...resourceNiche(banner),xmh5_ziyuanwei_position: index+1})"
        :key="banner.id"
        :style="{ backgroundImage: 'url(' + banner.resImgUrl + ')' }"
        @click="toBannerLink(banner, index)"
      >
        <!-- 安卓手机，并且url为外链 -->
<!--        <template v-if="/(http|https):\/\/([\w.]+\/?)\S*/.test(banner.jumpTargetUrl)">-->
<!--          <a v-if="/(http|https):\/\/([\w.]+\/?)\S*/.test(banner.jumpTargetUrl)" :href="banner.jumpTargetUrl"></a>-->
<!--        </template>-->
      </div>
    </mySwiper>
    <template  v-for="(banner,index) in bannerList">
      <div class="hometagWrap" v-if="banner.jumpType === 3"  :key="banner.resImgUrl" v-show="activeIndex == index">
        <openWxTag
          :id="'homeBanner'+banner.id"
          :path="banner.jumpTargetUrl"
          :appId="banner.miniProgramTypeAppId"
          btnStyle="width:100%;height:100px"
          @sensorsFn="toBannerLink(banner, index)"
        ></openWxTag>
      </div>
    </template>
  </div>
</template>

<script>
import mySwiper from "@/components/common/mySwiper/mySwiper.vue" //轮播图
import {goToMini,TestUserAgent,resourceNiche} from "@/assets/js/common.js";
import openWxTag from "@/components/common/openWeappTag/index.vue";
import {BuiedPointClick_Fn,Exposurer_Fn, xmhziyuanwei_data_expo} from '@/assets/js/BuriedPointEvent'
import { getPageListOnLine } from "@/utils/commonApiList.js";
import * as until from "@assets/js/common";

export default {
  name: "homeBanner",
  data() {
    return {
      bannerList: null, //banner列表
      UserInfo: null,
      unionid: "",
      isSystem:'',
      activeIndex: 0,
      sensorsIndex:0,
    }
  },
  components:{ mySwiper,openWxTag },
  created() {
     this.getBannerList()
  },
  mounted() {
    this.isSystem = TestUserAgent().isios;
  },
  methods: {
    resourceNiche,
    goToMini,
     slideChange(index) {
      this.sensorsIndex = this.sensorsIndex + 1
      // this.activeIndex = index == (this.bannerList.length >= 5 ? 6 :this.bannerList.length+1 ) ? 0 : index-1;
       this.activeIndex = index == this.bannerList.length + 1 ? 0 : index - 1
      if(this.sensorsIndex <= this.bannerList.length){
        sensors.track("xmhh5_home_banner_view", {
          xmhh5_home_banner_url: this.bannerList[this.activeIndex].jumpTargetUrl,
          banner_station: this.activeIndex
        });
      }
       // console.log(this.activeIndex, 'xmh5_ziyuanwei_view')
       // xmhziyuanwei_data_expo.observe('xmh5_ziyuanwei_view','.swiper-slide',false)
   },
    // 获取banner列表
    getBannerList() {
      const params = {
        pageNum: 1,
        pageSize: 6,
        locationType: 3,
      }
      getPageListOnLine(params).then(res => {
        if(res.code == 200){
          this.bannerList = res.data.data
          this.$nextTick(()=>{
            xmhziyuanwei_data_expo.observe('xmh5_ziyuanwei_view','.homebann',false)
          })
        }
      })
    },
    toDetailBanner(id){
      let index = this.bannerList.findIndex((item, index) => {
        return item.id == id;
      });
      until.advertisJump(this.bannerList[index],this).then((res)=>{
        const doctorInfo = {
          ...res,
          contentUrl: res.jumpTargetUrl,
          contentPayUrl: res.jumpTargetUrl,
        }
        this.$emit('homeBannerClick', doctorInfo)
      })
    },
    // banner点击
    toBannerLink(item, index) {
      BuiedPointClick_Fn("xmhh5_home_banner_click",{
        xmhh5_home_banner_url: item.jumpTargetUrl,
        banner_station: index+1
      })
      sensors.track('xmh5_ziyuanwei_click',{
        ...resourceNiche(item),
        xmh5_ziyuanwei_position: index+1
      })
    }
  }
}
</script>

<style lang="less" scoped>
.banner_recommend {
  margin: 8px 16px 0;
  position: relative;
  z-index: 8;
  /deep/.mySwiper .swiper-container {
    height: 80px;
    overflow: hidden !important;
    padding-bottom: 0!important;
    .swiper-wrapper{
      .swiper-slide {
        height: 80px;
        border-radius: 8px;
      }
    }
    //
    .swiper-pagination-clickable{
      text-align: right;
      width: 87vw;
      margin-right: 16px;
      .swiper-pagination-bullet{
        width: 8px;
        height: 3px;
        background: #FFFFFF;
        border-radius: 3px;
        opacity: 0.5;
        margin: 0 3px;
        &.swiper-pagination-bullet-active{
          opacity: 1;
        }
      }

    }
  }
  .hometagWrap{
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 80px;
      z-index: 999;
      a{
        display: block;
        width: 100%;
        height: 80px;
      }
    }
}
</style>
